/* eslint-disable padding-line-between-statements */
import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import metadata from './DeactivateAgency.metadata.json5';
import styles from './DeactivateAgency.module.scss'
import PropTypes from 'prop-types';
import { useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { AgencyAdminService } from '../../../../capabilities/twia-capability-agencyadmin';
import { useValidation } from '@xengage/gw-portals-validation-react';


function DeactivateAgency(props) {
    const {
        onCancel,
        onSubmit,
        history,
        groupPublicID,
        cancelDeactivateAgency,
        id
    } = props;
    const { onValidate, isComponentValid, registerComponentValidation } =
    useValidation('DeactivateAgency');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const [deactivateVM, setDeactivateVM]  = useState();
    const [showErrors, setShowErrors] = useState(false);
    const { refreshData } = useDataRefresh();
      _.set(deactivateVM,'publicID', groupPublicID)
    useEffect(() => {
        const deactivateAgency = viewModelService.create(
            {},
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.AgencyDeactivateInfoDTO'
        )
        setDeactivateVM(deactivateAgency);
    },[]);

    useCallback(() => {
        if (onValidate) {
          onValidate(isComponentValid, id);
        }
      }, [id, isComponentValid, onValidate]);


    const writeValue = useCallback(
        (value, path) => {
            _.set(deactivateVM, `${path}.value`, value);
            setDeactivateVM(deactivateVM);
            refreshData();
        },
        [deactivateVM, refreshData]
    );

    const cancel = useCallback(() =>{
        cancelDeactivateAgency(true)
    })

    const submit = useCallback(() => {
    
        // DE15309 - TWIA/TFPA Deactivate Agency Submit button inactive by default
        if (!isComponentValid) {
            setShowErrors(true)
            return false
        }
        AgencyAdminService.deactivateAgency(deactivateVM.value, authHeader).then((res) => {    
        }, (err) => {
        });
         history.go('/administration');
    })
    

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showErrors,
            phoneWide: {
                labelPosition: 'top',
            },
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            clickCancel: cancel,
            clickSubmit: submit
        }
    };


    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={deactivateVM}
                overrideProps={overrideProps}              
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                />
        );
}

DeactivateAgency.propTypes = {  
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(withRouter(DeactivateAgency));
